var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-screen h-screen flex flex-col justify-center items-center"},[_c('h1',{staticClass:"four mb-8"},[_vm._v("404")]),_c('h3',{staticClass:"nf mb-8"},[_vm._v("Page Not Found")]),_c('vs-button',{attrs:{"color":"primary","size":"large"},on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Go Back")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }